import payload_plugin_qLmFnukI99 from "/src/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import nuxt3_plugin_BdfRvWAAOY from "/src/node_modules/vue-yandex-maps/dist/plugins/nuxt3-plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/src/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/src/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import plugin_PSbK9A48ZQ from "/src/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import plugin_eTVJQYlCmx from "/src/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import plugin_WLsn00x1qh from "/src/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import _10_apollo_dLoLNWdBlw from "/src/src/app/plugins/10.apollo.ts";
import _20_auth_client_9CKstVJ5tt from "/src/src/app/plugins/20.auth.client.ts";
import _30_storeInit_client_v7fEhSG5yt from "/src/src/app/plugins/30.storeInit.client.ts";
import _35_projectRouteBack_client_sIRP1Ngb1F from "/src/src/app/plugins/35.projectRouteBack.client.ts";
import _36_authRouteBack_client_OH6WWZUMuJ from "/src/src/app/plugins/36.authRouteBack.client.ts";
import Vue3Lottie_client_2jl2MsUzTv from "/src/src/app/plugins/Vue3Lottie.client.ts";
import firebase_client_t0axORo95o from "/src/src/app/plugins/firebase.client.ts";
import maska_CYmNjdvLFy from "/src/src/app/plugins/maska.ts";
import network_client_kDWpeecZch from "/src/src/app/plugins/network.client.ts";
import theme_VhUo8lrH1p from "/src/src/app/plugins/theme.ts";
import ssg_detect_3fHkBxLtv0 from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  nuxt3_plugin_BdfRvWAAOY,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  plugin_PSbK9A48ZQ,
  plugin_eTVJQYlCmx,
  plugin_WLsn00x1qh,
  _10_apollo_dLoLNWdBlw,
  _20_auth_client_9CKstVJ5tt,
  _30_storeInit_client_v7fEhSG5yt,
  _35_projectRouteBack_client_sIRP1Ngb1F,
  _36_authRouteBack_client_OH6WWZUMuJ,
  Vue3Lottie_client_2jl2MsUzTv,
  firebase_client_t0axORo95o,
  maska_CYmNjdvLFy,
  network_client_kDWpeecZch,
  theme_VhUo8lrH1p,
  ssg_detect_3fHkBxLtv0
]